export default function getUniqueObjects(array) {
    const uniqueSet = new Set(array.map(JSON.stringify));
    return Array.from(uniqueSet, JSON.parse);
  }